import React, { useEffect } from "react";
import { driver } from "driver.js";
import "driver.js/dist/driver.css";
import { Tooltip } from "antd";

function DriverButton(props) {
  const renderDriverSteps = () => {
    const closeTooltip = () => {
      driverObj.destroy();
    };

    switch (props.driverFlag) {
      case "dashboard":
        return [
          {
            element: ".driver-review-account",
            popover: {
              title: "Review My Account",
              description: `<p class="">Here, you can view and edit your profile settings and candidate details.</p>`,
              prevBtnText: "Previous",
              nextBtnText: "Next",
            },
            onHighlighted: (element) => {
              element.addEventListener("click", closeTooltip);
            },
          },
          {
            element: `.driver-performance-insights`,
            popover: {
              title: "Performance insights",
              description: `<p class="">Here, you can see your performance.</p>`,
              prevBtnText: "Previous",
              nextBtnText: "Next",
            },
            onHighlighted: (element) => {
              element.addEventListener("click", closeTooltip);
            },
          },
          {
            element: `.driver-dashboard-preparation-guide`,
            popover: {
              title: "Preparation guide",
              description: `<p class="">Your Preparation guide will be displayed here.</p>`,
              prevBtnText: "Previous",
              nextBtnText: "Next",
            },
            onHighlighted: (element) => {
              element.addEventListener("click", closeTooltip);
            },
          },
          {
            element: `.driver-mock-test`,
            popover: {
              title: "Mock test",
              description: `<p class="">Practice your mock test here.</p>`,
              prevBtnText: "Previous",
              doneBtnText: "Finish",
            },
            onHighlighted: (element) => {
              element.addEventListener("click", closeTooltip);
            },
          },
        ];
      case "viewAllGuide":
        return [
          {
            element: ".driver-all-guide-search",
            popover: {
              title: "Search for guides",
              description: `<p class="">You can search for any guide which you have created in the past.</p>`,
              prevBtnText: "Previous",
              nextBtnText: "Next",
            },
            onHighlighted: (element) => {
              element.addEventListener("click", closeTooltip);
            },
          },
          {
            element: ".driverjs-all-guide-status-filter",
            popover: {
              title: "Status filter",
              description: `<p class="">Filter Guide based on status which can be 1.Active 2.Draft</p>`,
              prevBtnText: "Previous",
              nextBtnText: "Next",
            },
            onHighlighted: (element) => {
              element.addEventListener("click", closeTooltip);
            },
          },
          {
            element: ".driverjs-all-guide-date-filer",
            popover: {
              title: "Date filter",
              description: `<p class="">Filter Guides based on the creation date.</p>`,
              prevBtnText: "Previous",
              nextBtnText: "Next",
            },
            onHighlighted: (element) => {
              element.addEventListener("click", closeTooltip);
            },
          },
          {
            element: ".driverjs-alljobs-individual-guide-card",
            popover: {
              title: "Guide card",
              description: `<p class="">It has all the basic details about the guide.</p>`,
              prevBtnText: "Previous",
              nextBtnText: "Next",
            },
            onHighlighted: (element) => {
              element.addEventListener("click", closeTooltip);
            },
          },
          {
            element: ".driver-js-guide-curr-status",
            popover: {
              title: "Current guide status",
              description: `<p class="">You can check the current guide status.</p>`,
              prevBtnText: "Previous",
              nextBtnText: "Next",
            },
            onHighlighted: (element) => {
              element.addEventListener("click", closeTooltip);
            },
          },
          {
            element: ".driverjs-all-guide-card-action-link",
            popover: {
              title: "View guide link",
              description: `<p class="">you can click here to view the guide that you have created.</p>`,
              prevBtnText: "Previous",
              doneBtnText: "Finish",
            },
            onHighlighted: (element) => {
              element.addEventListener("click", closeTooltip);
            },
          },
          //   driverjs-all-guide-card-action-link
        ];
      case "create-new-draft":
        return [
          {
            element: ".driver-new-guide-form",
            popover: {
              title: "Form",
              description: `<p>Fill the form to create your guide.</p>`,
              prevBtnText: "Previous",
              nextBtnText: "Next",
            },
            onHighlighted: (element) => {
              element.addEventListener("click", closeTooltip);
            },
          },
          {
            element: ".driver-job-description",
            popover: {
              title: "Job description",
              description: `<p>Here you can Generate your JD or you can upload your document.</p>`,
              prevBtnText: "Previous",
              nextBtnText: "Next",
            },
            onHighlighted: (element) => {
              element.addEventListener("click", closeTooltip);
            },
          },
          {
            element: ".driver-save-draft-button",
            popover: {
              title: "Save draft",
              description: `<p>Save your data and continue creating a new guide in the future.</p>`,
              prevBtnText: "Previous",
              nextBtnText: "Next",
            },
            onHighlighted: (element) => {
              element.addEventListener("click", closeTooltip);
            },
          },
          {
            element: ".driver-create-guide-button",
            popover: {
              title: "Create guide",
              description: `<p>Click the button to create your guide.</p>`,
              prevBtnText: "Previous",
              doneBtnText: "Finish",
            },
            onHighlighted: (element) => {
              element.addEventListener("click", closeTooltip);
            },
          },
        ];
      case "settings":
        return [
          {
            element: ".driver-profile",
            popover: {
              title: "Profile",
              description: `<p>Change your personal details and password here.</p>`,
              prevBtnText: "Previous",
              nextBtnText: "Next",
            },
            onHighlighted: (element) => {
              element.addEventListener("click", closeTooltip);
            },
          },
          {
            element: ".driver-candidate",
            popover: {
              title: "Candidate",
              description: `<p>Change your candidate details here.</p>`,
              prevBtnText: "Previous",
              doneBtnText: "Finish",
            },
            onHighlighted: (element) => {
              element.addEventListener("click", closeTooltip);
            },
          },
        ];
      case "viewSingleGuide":
        return [
          {
            element: ".driver-single-guide-progress-bar",
            popover: {
              title: "Track your progress",
              description: `<p class="">You can track your progress with respect to the Topics and subtopics you've completed.</p>`,
              prevBtnText: "Previous",
              nextBtnText: "Next",
            },
            onHighlighted: (element) => {
              element.addEventListener("click", closeTooltip);
            },
          },
          {
            element: ".driver-single-guide-topic-subtopic-section",
            popover: {
              title: "Topics and sub-topics section",
              description: `<p class="">Here is  list of all the topics and subtopics available in your guide.</p>`,
              prevBtnText: "Previous",
              nextBtnText: "Next",
            },
            onHighlighted: (element) => {
              element.addEventListener("click", closeTooltip);
            },
          },
          {
            element: ".driver-single-guide-subtopic-section",
            popover: {
              title: "Sub-topic list",
              description: `<p class="">User must click on each of the sub-topic in order to see the preparation content.</p>`,
              prevBtnText: "Previous",
              nextBtnText: "Next",
            },
            onHighlighted: (element) => {
              element.addEventListener("click", closeTooltip);
            },
          },
          {
            element: ".driver-single-guide-generated-guide-content",
            popover: {
              title: "Sub-topic content",
              description: `<p class="">All the subtopic content appears here.</p>`,
              prevBtnText: "Previous",
              nextBtnText: "Next",
            },
            onHighlighted: (element) => {
              element.addEventListener("click", closeTooltip);
            },
          },
          {
            element: ".driver-single-guide-user-details-section",
            popover: {
              title: "User detail section",
              description: `<p class="">This section has user and guide details.</p>`,
              prevBtnText: "Previous",
              nextBtnText: "Next",
            },
            onHighlighted: (element) => {
              element.addEventListener("click", closeTooltip);
            },
          },
          {
            element: ".driver-single-guide-user-notes-section",
            popover: {
              title: "Notes",
              description: `<p class="">User can mantain notes for their reference.</p>`,
              prevBtnText: "Previous",
              doneBtnText: "Finish",
            },
            onHighlighted: (element) => {
              element.addEventListener("click", closeTooltip);
            },
          },
        ];
      default:
        return [];
    }
  };

  const driverObj = driver({
    popoverClass: "driverjs-theme",
    showProgress: true,
    steps: renderDriverSteps(),
  });

  const startTour = () => {
    driverObj.drive();
  };

  useEffect(() => {
    return () => {
      driverObj.destroy();
    };
  }, [driverObj]);

  return (
    <div className="mr-3">
      <Tooltip
        color={"white"}
        overlayInnerStyle={{ color: "black" }}
        placement="bottom"
        // title="Start Demo Tour"
      >
        <div onClick={startTour} className="driver-button flex gap-2 justify-center items-center">
          <span className=" text-base text-[#101828] font-semibold">
            Start Demo Tour
          </span>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="23"
            height="23"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            className="lucide lucide-circle-help"
          >
            <circle cx="12" cy="12" r="10" />
            <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
            <path d="M12 17h.01" />
          </svg>
        </div>
      </Tooltip>
    </div>
  );
}

export default DriverButton;
